import { render, staticRenderFns } from "./new_message_design.vue?vue&type=template&id=24ed3e75"
import script from "./new_message_design.vue?vue&type=script&lang=js"
export * from "./new_message_design.vue?vue&type=script&lang=js"
import style0 from "./new_message_design.vue?vue&type=style&index=0&id=24ed3e75&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports